<template>
  <div ref="scroller">
    <slot></slot>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    threshold: {
      type: Number,
      default: 0.5
    },
    top: {
      type: Number,
      default: 0.5
    },
    bottom: {
      type: Number,
      default: 0.3
    }
  },
  data() {
    return {
      index: 0,
      offset: 0,
      progress: -1,
      activeSections: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      const foreground = this.$slots.default.filter(
        s => s.data.ref === "foreground"
      )[0].elm;

      const sections = foreground.childNodes;

      window.addEventListener("scroll", () => {
        let activeSections = [];

        let foregroundTop =
          foreground.getBoundingClientRect().top -
          window.innerHeight * this.threshold;
        let foregroundHeight = foreground.getBoundingClientRect().height;

        let progress = -foregroundTop / foregroundHeight;

        this.$emit("progress", { value: progress });

        _.forEach(sections, (section, index) => {
          let top =
            section.getBoundingClientRect().top -
            window.innerHeight * this.threshold;
          let height = section.getBoundingClientRect().height;

          let offset = -top / height;

          if (offset >= 0 && offset <= 1) {
            this.$emit("offset", { value: offset });
            this.$emit("index", { value: index });
          }

          // list of section in viewport
          if (
            section.getBoundingClientRect().top <
              window.innerHeight * this.bottom &&
            section.getBoundingClientRect().bottom >
              window.innerHeight * this.top
          ) {
            activeSections.push(index);

            this.$emit("activeSections", { value: activeSections });
          }
        });
      });
    });
  }
};
</script>
